import { render, staticRenderFns } from "./CheckPage.vue?vue&type=template&id=3d9ecd12&scoped=true&"
import script from "./CheckPage.vue?vue&type=script&lang=js&"
export * from "./CheckPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ecd12",
  null
  
)

export default component.exports